import "../../../node_modules/slick-carousel/slick/slick";
import "./theme/autoload";
